import { z } from "zod"
import {
  Customer,
  createEmptyCustomer,
  useCustomersActions,
} from "@/api/customers"
import { customerFormSchema } from "./customer.schema"
import { toast } from "sonner"
import CustomerForm from "./customer.form"
import { SheetClose, SheetFooter } from "@/components/ui/sheet"
import { Button } from "@/components/ui/button"

interface CustomerCreateProps {
  onDone: (customer?: Customer) => void;
}

export default function CustomerCreate({ onDone }: CustomerCreateProps) {
  const { create } = useCustomersActions()

  const onSubmit = async (data: z.infer<typeof customerFormSchema>) => {
    const customer = await create(data)
    toast.success("Customer added")
    onDone(customer)
  }

  return (
    <CustomerForm onSubmit={onSubmit} defaultValues={createEmptyCustomer()}>
      <SheetFooter>
        <SheetClose asChild>
          <Button variant="outline" type="button">
            Cancel
          </Button>
        </SheetClose>
        <Button type="submit">Add customer</Button>
      </SheetFooter>
    </CustomerForm>
  )
}
